<template>
  <div>
    <div class="d-md-flex align-center justify-space-between">
        <div style="display:inline-flex">
            <h1 class="mb-0 mr-3 pt-1">
                Mass Manage Affiliate PID
            </h1>
        </div>
    </div>

    <v-data-table
      :headers="table.headers"
      :header-props="{ sortIcon: null, headerClass: 'white-space-no-wrap' }"
      :items="getAffiliatesProfileCO.data"
      :server-items-length="getAffiliatesProfileCO.count"
      :disable-sort="false"
      :loading="table.loading"
      :footer-props="{itemsPerPageOptions: table.pageOptions}"
      :page="table.currentPage"
      :items-per-page="table.perPage"
      loading-text="Loading... Please wait"
      fixed-header
      :class="`elevation-1 fixed-height co-data-table items-size-${table.heightCounter}`"
      item-class="td_title"
      color="#7F98A5"
      @pagination="updateTablePagination"
      :show-select="table.showSelect"
      @input="onSelect"
      @click:row="selectAffiliate"
      @update:sort-by="updateSortBy"
      @update:sort-desc="updateSortDesc"
    >
      <template v-slot:top>
        <DataTableTopBar @search="search" :isDisplaySettings="true" :headers="table.headers.map(h=>h.text)" headerType="affiliateHeader"></DataTableTopBar>
      </template>

      <template v-for="item of table.headers" :slot="`header.${[item.value]}`" slot-scope="{header}">
        <div class="d-flex align-center">
          <data-filter
            :type="table.filters[header.value]['isDate'] ? 'date' : 'items'"
            v-if="table.filters.hasOwnProperty(header.value)"
            :items="table.filters[header.value].data"
            :entity="header.value"
            :values="table.filters[header.value].selected"
            @apply="submitFilter"
            @search="updateDataInFilters"
          ></data-filter>
          <span class="ml-2">
        <a v-if="header.sortable === undefined || header.sortable" @click="sortColumn(header.value)">
          <span class="header_title">{{header.text}}</span>
          <v-icon size="16" color="#7F98A5">mdi-arrow-{{header.value === table.orderBy ? (table.sortColumnsAsc ? 'up' : 'down') : 'up-down'}}</v-icon>
        </a>
        <span v-else class="header_title">{{header.text}}</span>
      </span>
        </div>
      </template>

      <template v-for="header of table.headers" :slot="`item.${[header.value]}`" slot-scope="{item}">
        <template v-if="header.value === 'affNameId'">
          <a class="entity-link">{{item[header.value]}}</a>
        </template>
        <template v-else-if="header.value === 'email'">
          <span>{{item.email}}</span>
        </template>
        <template v-else-if="header.value === 'status'">
          <short-text :text="item[header.value]"></short-text>
        </template>
        <template v-else-if="header.value === 'companyCount'">
          {{item[header.value]}}
        </template>
        <template v-else-if="header.value === 'affiliateManager'">
          {{item[header.value]}}
        </template>
        <template v-else-if="header.value === 'billingCycle'">
          {{item[header.value]}}
        </template>
        <template v-else-if="header.value === 'paymentType'">
          <short-text :text="item[header.value]"></short-text>
        </template>
        <template v-else-if="header.value === 'affiliateType'">
          {{item[header.value]}}
        </template>
        <template v-else-if="header.value === 'trafficType'">
          {{item[header.value]}}
        </template>
        <template v-else-if="header.value === 'dateAdded'">
          {{getPrettyDate(item.dateAdded)}}
        </template>
        <template v-else>
          {{item[header.value]}}
        </template>
      </template>
    </v-data-table>

    <v-dialog v-model="dialog" max-width="1700px" persistent>
      <v-card class="fixed-dialog">
        <v-card-title class="d-flex align-center justify-space-between">
          <h3 class="mb-0 mr-3 pt-1 d-flex align-center">
            Companies of Affiliate:
            {{ selectedAffiliate ? `${selectedAffiliate.name} (${selectedAffiliate.id})` : '' }}
            <v-chip class="ml-2" :color="canManageCampaigns ? 'green' : 'grey'" small>
              {{ canManageCampaigns ? 'Edit Mode' : 'Read-Only' }}
            </v-chip>
          </h3>

          <div class="header-actions">
            <v-text-field
              v-model="companySearch"
              label="Search by ID, Name, PID"
              prepend-inner-icon="mdi-magnify"
              class="company-search"
            ></v-text-field>

            <v-icon class="close-btn" @click="closeDialog">mdi-close</v-icon>
          </div>
        </v-card-title>

        <v-card-text class="dialog-content">
          <v-data-table
            :headers="companyHeaders"
            :items="filteredCompanies"
            :items-per-page="table.perPage"
            :footer-props="{ itemsPerPageOptions: table.pageOptions }"
          >
            <template v-slot:item.name="{ item }">
              {{ item.name }}
            </template>
            <template v-slot:item.status="{ item }">
              {{ item.status }}
            </template>
            <template v-slot:item.sub_ids="{ item }">
              <v-autocomplete
                v-model="item.sub_ids_filtered"
                :items="item.sub_ids_filtered"
                multiple
                chips
                small-chips
                deletable-chips
                :menu-props="{ maxHeight: '400' }"
                class="custom-autocomplete"
                label="Add or remove PIDs"
                placeholder="Enter PID and press Enter"
                persistent-placeholder
                @change="updateSubIds(item)"
                @keydown.enter.native.prevent="addNewPid(item)"
                :search-input.sync="item.searchTags"
                :disabled="!canManageCampaigns"
                :class="{'readonly-autocomplete': !canManageCampaigns}"
              >
                <template v-slot:selection="{ item: tag, index }">
                  <v-chip small label close color="primary" @click:close="removePid(item, index)">
                    {{ tag }}
                  </v-chip>
                </template>
                <template v-slot:no-data>
                  <span>Press Enter to create a new PID</span>
                </template>
              </v-autocomplete>
            </template>
            <template v-slot:item.actions="{ item }">
              <div class="d-flex align-center">
                <v-btn v-if="item.hasChanges" color="primary" small @click="saveSubIds(item)">
                  Save
                </v-btn>
                <v-icon v-if="item.saveSuccess" color="success" class="ml-2">
                  mdi-check-circle
                </v-icon>
                <v-tooltip bottom v-if="item.saveError">
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon color="error" class="ml-2" v-bind="attrs" v-on="on">
                      mdi-alert-circle
                    </v-icon>
                  </template>
                  <span>Failed to save. Try again.</span>
                </v-tooltip>
              </div>
            </template>
          </v-data-table>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </div>
</template>

<script>
import {mapGetters, mapState} from "vuex";
import store from "@/store";
import DataTableTopBar from "@/components/common/DataTableTopBar.vue";
import campaignsApi from "@/api/campaigns";
import affiliatesApi from "@/api/affiliates";
import {DateTime} from "luxon";
import affiliates from "@/api/affiliates";

export default {
  components: { DataTableTopBar },
  data() {
    return {
      dialog: false,
      companySearch: '',
      selectedAffiliate: null,
      table: {
        searchInAffiliates: '',
        headers: [
          { text: 'Affiliate Name & ID', value: 'affNameId', align: 'center' },
          { text: 'Email', value: 'email', align: 'center' },
          { text: 'Status', value: 'status', align: 'center' },
          { text: 'Campaign Count', value: 'companyCount', align: 'center' ,sortable:true},
          { text: 'Affiliate Manager', value: 'affiliateManager', align: 'center' },
          { text: 'Billing Cycle', value: 'billingCycle', align: 'center' },
          { text: 'Payment Type', value: 'paymentType', align: 'center' },
          { text: 'Affiliate Type', value: 'affiliateType', align: 'center' },
          { text: 'Traffic Type', value: 'trafficType', align: 'center' },
          { text: 'Date Added', value: 'dateAdded', align: 'center' },
        ],
        filters: {
          affNameId: { selected: [], data: [] },
          email: { selected: [], data: [] },
          status: { selected: [], data: [] },
          affiliateManager: { selected: [], data: [] },
          billingCycle: { selected: [], data: [] },
          dateAdded: { selected: [], data: [], isDate: true },
        },
        orderBy: '',
        sortColumnsAsc: false,
        loading: false,
        pageOptions: [10, 25, 50, 100],
        currentPage: 1,
        perPage: 25,
        heightCounter: 10,
        showSelect: false,
      },
      companies: [],
      companyHeaders: [
        { text: 'Id', value: 'id', sortable: false },
        { text: 'Name', value: 'name', sortable: false },
        { text: 'Status', value: 'status', sortable: false },
        { text: 'PID', value: 'sub_ids', sortable: false },
        { text: 'Actions', value: 'actions', sortable: false }
      ],
    };
  },
  computed: {
    ...mapGetters('affiliates', ['getAffiliatesProfileCO']),
    ...mapState('user', ['user']),
    canManageCampaigns() {
      return this.user && this.user[0] && this.user[0].can('manage_campaigns');
    },
    filteredCompanies() {
      if (!this.companySearch) {
        return this.companies;
      }
      const search = this.companySearch.toLowerCase();
      return this.companies.filter(company =>
        (company.id && company.id.toString().includes(search)) ||
        (company.name && company.name.toLowerCase().includes(search)) ||
        (company.sub_ids_filtered && company.sub_ids_filtered.some(pid => pid.toLowerCase().includes(search)))
      );
    }
  },
  methods: {
    addNewPid(item) {
      if (!item.searchTags) return;

      const newPid = item.searchTags.trim();
      if (newPid && !item.sub_ids_filtered.includes(newPid)) {
        item.sub_ids_filtered.push(newPid);
        this.updateSubIds(item);
      }

      this.$nextTick(() => {
        item.searchTags = "";
      });
    },
    removePid(item, index) {
      item.sub_ids_filtered.splice(index, 1);
      this.updateSubIds(item);
    },
    getPrettyDate(date) {
      return DateTime.fromISO(date).toFormat('MMMM dd, yyyy');
    },
    closeDialog() {
      this.dialog = false;
    },
    async saveSubIds(item) {
      try {
        const success = await campaignsApi.updateCampaignSubIds({
          campaignId: item.id,
          sub_ids: item.sub_ids
        });

        if (success) {
          item.original_sub_ids = item.sub_ids;
          item.hasChanges = false;
          this.$set(item, 'saveSuccess', true);
          this.$set(item, 'saveError', false);
          console.log(`✅ Successfully saved sub_ids for campaign ${item.id}`);

          setTimeout(() => {
            item.saveSuccess = false;
          }, 6000);
        } else {
          this.$set(item, 'saveError', true);
          console.error(`⚠️ Failed to save sub_ids for campaign ${item.id}`);

          // setTimeout(() => {
          //   item.saveError = false;
          // }, 10000);
        }
      } catch (error) {
        this.$set(item, 'saveError', true);
        console.error("❌ Error saving sub_ids:", error);

        // setTimeout(() => {
        //   item.saveError = false;
        // }, 6000);
      }
    },

    async search(query) {
      this.table.searchInAffiliates = query;
      if (this.table.searchInAffiliates) {
        this.table.currentPage = 1;
      }
      this.table.loading = true;
      await this.getTableData();
      this.table.loading = false;
    },
    async updateTablePagination(event) {
      this.table.currentPage = event.page;
      this.table.perPage = event.itemsPerPage;
      await this.getTableData();
    },
    async onSelect(selection) {
      console.log("Selected items:", selection);
    },
    async selectAffiliate(affiliate) {
      console.log("Selected Affiliate:", affiliate);
      this.selectedAffiliate = affiliate;
      this.dialog = true;
      this.companies = await this.fetchCompanies(affiliate.id);
    },
    async fetchCompanies(affiliateId) {
      const response = await campaignsApi.getCampaignsData({
        payload: {
          orderBy: 'dateAdded',
          orderDirectionAsc: false,
          page: 1,
          limit: 1000,
          filters: { affiliateId },
          showInactiveCampaigns: false,
        }
      });

      return response.data.map(company => ({
        ...company,
        sub_ids_filtered: (() => {
          try {
            const parsedSubIds = JSON.parse(company.sub_ids);
            return Array.isArray(parsedSubIds)
              ? parsedSubIds.filter(sub => sub.name === "afftpid").map(sub => sub.value)
              : [];
          } catch (error) {
            console.error("Error parsing sub_ids:", error);
            return [];
          }
        })(),
        original_sub_ids: company.sub_ids
      }));
    },

    updateSubIds(item) {
      try {
        let originalSubIds = [];
        if (typeof item.sub_ids === "string") {
          originalSubIds = JSON.parse(item.sub_ids);
        } else if (Array.isArray(item.sub_ids)) {
          originalSubIds = [...item.sub_ids];
        }

        let filteredSubIds = originalSubIds.filter(sub => sub.name !== "afftpid");

        let newAffpids = item.sub_ids_filtered.map(value => ({ name: "afftpid", value }));

        let updatedSubIds = [...filteredSubIds, ...newAffpids];

        item.sub_ids = JSON.stringify(updatedSubIds);

        item.hasChanges = item.sub_ids !== item.original_sub_ids;

        console.log("Updated sub_ids for backend:", item.sub_ids);
      } catch (error) {
        console.error("Error updating sub_ids:", error);
      }
    },
    updateSortBy(sortBy) {
      this.table.orderBy = sortBy;
      this.getTableData();
    },
    updateSortDesc(sortDesc) {
      this.table.sortColumnsAsc = !sortDesc;
      this.getTableData();
    },
    getFiltersData() {
      const filters = {};
      for(const name in this.table.filters) {
        affiliatesApi.getFilter({
          filter: filters,
          name: name,
        }).then(res => {
          console.log(`Filter data for ${name}:`, res);
          this.table.filters[name].data = res;
        }).catch(error => {
          console.error(`Error fetching filter data for ${name}:`, error);
        });
      }
    },
    updateDataInFilters(data, modalName) {
      if (modalName && this.table.filters[modalName]) {
        affiliatesApi.getFilter({
          filter: this.table.filters,
          name: modalName,
          searchFilter: data
        }).then(res => {
          this.table.filters[modalName].data = res;
        });
      }
    },
    async submitFilter(data, entity) {
      this.table.currentPage = 1;
      if(data && entity) {
        this.table.filters[entity].selected = data;
      }
      await this.getTableData();
    },
    async removeAllFilters() {
      for (let key in this.table.filters) {
        this.table.filters[key].selected = [];
      }
      await this.getTableData();
    },
    async getTableData() {
      this.table.loading = true;
      const filters = {
        search: this.table.searchInAffiliates,
        companyCount: true
      };

      for(const name in this.table.filters) {
        if(this.table.filters[name].selected.length > 0) {
          filters[name] = this.table.filters[name].selected;
        }
      }

      await store.dispatch('affiliates/getAffiliatesProfileDataCO', {
        payload: {
          limit: this.table.perPage,
          page: this.table.currentPage,
          orderBy: this.table.orderBy || '',
          orderDirectionAsc: this.table.sortColumnsAsc || false,
          filters: filters
        }
      });
      this.table.loading = false;
    }
  },
  async mounted() {
    this.platform = await affiliates.getPlatform()
    if (this.platform === 1){
      await this.$router.push('/403');
    }
    this.getTableData();
    this.getFiltersData();
  }
};
</script>

<style lang="sass" scoped>
.co-data-table
  .v-data-table__wrapper
    .v-data-table-header
      th
        white-space: nowrap
    max-height: 600px
    overflow-y: auto

    tbody
      tr
        margin-bottom: 8px

        td
          text-align: center
          padding: 14px 18px
          border-bottom: 1px solid #e0e0e0

        &:hover
          background-color: #f1f1f1

  .v-data-table-header
    th
      white-space: nowrap
      background-color: #f8f9fa
      font-weight: bold
      border-bottom: 2px solid #dee2e6
      padding: 12px 16px

.search_btn_wrap
  h1
    margin-bottom: 0

  .search_wrapper
    width: 250px
    padding-bottom: 15px

.verticals-container
  display: flex
  flex-wrap: wrap
  justify-content: flex-start
  gap: 4px

.readonly-autocomplete
  background-color: #f0f0f0 !important
  opacity: 0.6
  pointer-events: none

::v-deep
  .readonly-autocomplete
    .v-input__control
      background-color: #f0f0f0 !important
      opacity: 0.6
      pointer-events: none

.header-actions
  display: flex
  align-items: center
  gap: 12px

.company-search
  max-width: 220px
  font-size: 14px
  padding: 2px 8px
  margin-right: 10px

  .v-input__control
    min-height: 36px !important

.close-btn
  font-size: 24px
  cursor: pointer
  transition: transform 0.2s ease
  align-self: flex-start
  margin-top: -5px

  &:hover
    transform: scale(1.2)

.fixed-dialog
  width: 100%
  max-width: 1700px
  height: 800px
  display: flex
  flex-direction: column
  overflow: hidden

.dialog-content
  flex: 1
  overflow-y: auto
  max-height: calc(800px - 120px)

.header-actions
  display: flex
  align-items: center
  gap: 12px

.company-search
  max-width: 220px
  font-size: 14px
  padding: 2px 8px
  margin-right: 10px

  .v-input__control
    min-height: 36px !important

.close-btn
  font-size: 24px
  cursor: pointer
  transition: transform 0.2s ease
  align-self: flex-start
  margin-top: -5px

  &:hover
    transform: scale(1.2)


</style>
